import { UpdatePasswordInput } from "@/domain/dtos/inputs";
import { z } from "zod";

export const UpdatePasswordInputSchema: z.ZodType<UpdatePasswordInput> =
  z.object({
    old_password: z.string(),
    password: z.string(),
    confirm_password: z.string(),
  });
